import {Image} from 'antd-mobile';
import React from 'react';
import {useTranslation} from 'react-i18next';
export interface CurrentRechargeProps {
  // 活动所对应的已完成充值次数
  currentCount: number;
}

interface TabItemProps {
  icon: string;
  activeIcon: string;
  // 活动所对应的已完成充值次数
  currentCount: number;
  // 该item代表哪个充值次数
  itemCount: number;
}

const TabItem = ({icon, activeIcon, currentCount, itemCount}: TabItemProps) => {
  return (
    <div
      className={`flex-1 ${currentCount + 1 > itemCount ? 'opacity-30' : ''}`}>
      <Image
        className="w-full h-12"
        src={currentCount + 1 === itemCount ? activeIcon : icon}
        fit="fill"
      />
    </div>
  );
};

const icons = [
  {
    icon: require('@/assets/icons/promotions/recharge-1.webp'),
    activeIcon: require('@/assets/icons/promotions/recharge-1-active.webp'),
  },
  {
    icon: require('@/assets/icons/promotions/recharge-2.webp'),
    activeIcon: require('@/assets/icons/promotions/recharge-2-active.webp'),
  },
  {
    icon: require('@/assets/icons/promotions/recharge-3.webp'),
    activeIcon: require('@/assets/icons/promotions/recharge-3-active.webp'),
  },
  {
    icon: require('@/assets/icons/promotions/recharge-4.webp'),
    activeIcon: require('@/assets/icons/promotions/recharge-4-active.webp'),
  },
];

const CurrentRecharge = ({currentCount}: CurrentRechargeProps) => {
  const {t} = useTranslation();
  return (
    <div className="flex flex-col gap-2 py-2 px-4">
      <span className="text-[#EFA75F] text-sm font-bold">
        {t('promotionsV2.yourCurrentRecharge')}
      </span>
      <div className="flex flex-row items-center gap-1">
        {icons.map((item, index) => (
          <TabItem
            key={index}
            icon={item.icon}
            activeIcon={item.activeIcon}
            currentCount={currentCount}
            itemCount={index + 1}
          />
        ))}
      </div>
    </div>
  );
};

export default CurrentRecharge;
